import { render, staticRenderFns } from "./BanPolicyForm.vue?vue&type=template&id=210e4740&"
import script from "./BanPolicyForm.vue?vue&type=script&lang=ts&"
export * from "./BanPolicyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports